import React from "react";
import { useLocation } from "react-router-dom";
import { CorporativoLoginDashboard } from "../VXLab/Corporativo/Mobile/CorporativoLoginDashboard";
import { UserDashboard } from "../UserDashboard";
import { UserDetailsDashboard } from "../UserDetailsDashboard";
import { NotFound } from "../NotFound";

/**
 * Catches any /backoffice-{section}-{clientName}-web path and renders the
 * appropriate backoffice screen. Falls back to NotFound.
 */
export const BackofficeRouter = () => {
  const { pathname } = useLocation();

  if (/^\/backoffice-login-.+-web$/.test(pathname)) {
    return <CorporativoLoginDashboard />;
  }
  if (/^\/backoffice-users-.+-web$/.test(pathname)) {
    return <UserDashboard />;
  }
  if (/^\/backoffice-user_details-.+-web$/.test(pathname)) {
    return <UserDetailsDashboard />;
  }

  return <NotFound />;
};
